export enum NPL_PILL_TYPES {
  BLURPLE = 'blurple',
  ERROR = 'error',
  NEUTRAL = 'neutral',
  ORANGE = 'orange',
  PINK = 'pink',
  SUCCESS = 'success'
}
